import React from 'react';
import path from 'path';
import {
  AddPanelNav64Icon,
  HideIcon,
  HomeIcon,
  DeviceLaptop24Icon,
  DeviceTabletPortrait24Icon,
  DeviceMobileLandscape24Icon,
  DeviceMobilePortrait24Icon,
} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import NavbarBrand from './NavbarBrand';
import NavbarButton from './NavbarButton';
import NavbarContainer from './NavbarContainer';
import NavbarLink from './NavbarLink';
import NavbarMenu from './NavbarMenu';
import NavbarWrapper from './NavbarWrapper';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {typeName, qualify, iconName} from '@packages/systems/wfdl-Qualified';
import NavbarWrapperType from './dataTypes/NavbarWrapperType';
import AddNavbarLinkType from './dataTypes/AddNavbarLinkType';
import SliderNavbarCollapseType from './dataTypes/SliderNavbarCollapseType';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EList,
  ELiteral,
  EEnum,
} from '@packages/systems/wfdl-ast';
import {MENU_STATE_HIDE} from '@packages/utilities/expression-path-constants';

const NavAddPanelIcon = wrapAddPanelIcon(AddPanelNav64Icon);

const DeviceLaptop = () => <DeviceLaptop24Icon size={20} />;
const DeviceTabletPortrait = () => <DeviceTabletPortrait24Icon size={20} />;
const DeviceMobileLandscape = () => <DeviceMobileLandscape24Icon size={20} />;
const DeviceMobilePortrait = () => <DeviceMobilePortrait24Icon size={20} />;

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelNav: NavAddPanelIcon,
    Nav: HomeIcon,
    DeviceLaptopSmall: DeviceLaptop,
    DeviceTabletPortrait16: DeviceTabletPortrait,
    DeviceMobileLandscape16: DeviceMobileLandscape,
    DeviceMobilePortrait16: DeviceMobilePortrait,
    EyeInvisibleSmall: HideIcon,
  },
  atoms: {
    NavbarBrand,
    NavbarButton,
    NavbarContainer,
    NavbarLink,
    NavbarMenu,
    NavbarWrapper,
  },
  dataTypes: {
    NavbarWrapper: NavbarWrapperType,
    AddNavbarLink: AddNavbarLinkType,
    SliderNavbarCollapse: SliderNavbarCollapseType,
  },
  elementPresets: {
    NavbarWrapper: ElementPreset.create({
      factory: EElement({
        id: 'Navbar Wrapper',
        type: qualify(Plugins.name('Navbar'), Component.name('NavbarWrapper')),
        data: ERecord({
          tag: EEnum('div'),
          temp: ERecord({
            navbar: ERecord({
              menu: EEnum(MENU_STATE_HIDE),
            }),
          }),
          navbar: ERecord({
            animation: EEnum('default'),
            collapse: EText('medium'),
            docHeight: EBoolean(false),
            duration: ENumber(400),
            easing: EEnum('ease'),
            easing2: EEnum('ease'),
            noScroll: EBoolean(false),
            type: EText('wrapper'),
          }),
          children: EList([
            EElement({
              id: 'Navbar Container',
              type: qualify(
                Plugins.name('Navbar'),
                Component.name('NavbarContainer')
              ),
              data: ERecord({
                tag: EEnum('div'),
                navbar: ERecord({
                  type: EText('container'),
                }),
                children: EList([
                  EElement({
                    id: 'Navbar Brand',
                    type: qualify(
                      Plugins.name('Navbar'),
                      Component.name('NavbarBrand')
                    ),
                    data: ERecord({
                      navbar: ERecord({
                        type: EText('brand'),
                      }),
                      children: EList([]),
                      link: ELiteral({
                        name: qualify(Plugins.name('Basic'), typeName('Link')),
                        value: {
                          mode: 'external',
                          url: '#',
                        },
                      }),
                      eventIds: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Navbar Menu',
                    type: qualify(
                      Plugins.name('Navbar'),
                      Component.name('NavbarMenu')
                    ),
                    data: ERecord({
                      tag: EEnum('nav'),
                      navbar: ERecord({
                        type: EText('menu'),
                      }),
                      attr: ERecord({
                        role: EText('navigation'),
                      }),
                      children: EList([
                        EElement({
                          id: 'Navbar Link',
                          type: qualify(
                            Plugins.name('Navbar'),
                            Component.name('NavbarLink')
                          ),
                          data: ERecord({
                            navbar: ERecord({
                              type: EText('link'),
                            }),
                            children: EList([
                              EElement({
                                id: 'Navbar Wrapper String',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('Home'),
                              }),
                            ]),
                            link: ELiteral({
                              name: qualify(
                                Plugins.name('Basic'),
                                typeName('Link')
                              ),
                              value: {
                                mode: 'external',
                                url: '#',
                              },
                            }),
                            eventIds: EList([]),
                          }),
                        }),
                        EElement({
                          id: 'Navbar Link 2',
                          type: qualify(
                            Plugins.name('Navbar'),
                            Component.name('NavbarLink')
                          ),
                          data: ERecord({
                            navbar: ERecord({
                              type: EText('link'),
                            }),
                            children: EList([
                              EElement({
                                id: 'Navbar Wrapper String 2',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('About'),
                              }),
                            ]),
                            link: ELiteral({
                              name: qualify(
                                Plugins.name('Basic'),
                                typeName('Link')
                              ),
                              value: {
                                mode: 'external',
                                url: '#',
                              },
                            }),
                            eventIds: EList([]),
                          }),
                        }),
                        EElement({
                          id: 'Navbar Link 3',
                          type: qualify(
                            Plugins.name('Navbar'),
                            Component.name('NavbarLink')
                          ),
                          data: ERecord({
                            navbar: ERecord({
                              type: EText('link'),
                            }),
                            children: EList([
                              EElement({
                                id: 'Navbar Wrapper String 3',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('Contact'),
                              }),
                            ]),
                            link: ELiteral({
                              name: qualify(
                                Plugins.name('Basic'),
                                typeName('Link')
                              ),
                              value: {
                                mode: 'external',
                                url: '#',
                              },
                            }),
                            eventIds: EList([]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Navbar Button',
                    type: qualify(
                      Plugins.name('Navbar'),
                      Component.name('NavbarButton')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      navbar: ERecord({
                        type: EText('button'),
                      }),
                      children: EList([
                        EElement({
                          id: 'Icon',
                          type: qualify(
                            Plugins.name('Icon'),
                            Component.name('Icon')
                          ),
                          data: ERecord({
                            widget: ERecord({
                              type: EText('icon'),
                              icon: EText('nav-menu'),
                            }),
                            children: EList([]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      icon: {
        small: qualify(Plugins.name('Navbar'), iconName('Nav')),
        medium: qualify(Plugins.name('Navbar'), iconName('AddPanelNav')),
      },
      label: 'Navbar',
      helpData: {
        description: [
          'A Navbar is your easy, breezy header/navigation menu builder. It includes a placeholder for your logo on the left, and a set of menu links on the right.',
          'On smaller screens, nav links collapse into a hamburger menu (expands when clicked).',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/navbar.3954247cbe.mp4',
      },
      category: 'Other',
      addTabIndex: 6,
    }),
  },

  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-navbar.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) => data.navbar && data.navbar.type === 'wrapper',
      },
    },
  ],
});
